/*
 * Public API Surface of ngx-autocomplete
 */

export * from './lib/autocomplete.service';
export * from './lib/autocomplete.component';
export * from './lib/autocomplete.module';
export * from './lib/pipes/highlight.pipe';
export * from './lib/pipes/pipes.module';
